__turbopack_context__.v({
  "checked": "zeniiW_checked",
  "icon": "zeniiW_icon",
  "indeterminate": "zeniiW_indeterminate",
  "indicator": "zeniiW_indicator",
  "root": "zeniiW_root",
});
